import { Segment, PointDirection, findFirstIntersectionsReversedWithCrossDirection } from "./intersection.Math";





export function computeMacdScan(data: anychart.data.Table, macdRule:any) {
  
  console.log("calculate macd 1");
 
//return false;;
  let fastperiod = macdRule.fast_period;
  let slowperiod = macdRule.slow_period;
  let signalperiod = macdRule.signal_period;
  

  var mapping = data.mapAs();
  mapping.addField('value', 4, 'last');
  mapping.addField("dt", 0);

  // Create computer.
  var computer = data.createComputer(mapping);

  var context = anychart.math.macd.initContext(fastperiod, slowperiod, signalperiod);

  // Set init context.
  computer.setContext(context);

  computer.setStartFunction( ctx=>{
                            anychart.math.macd.startFunction(<anychart.math.macd.Context>ctx);
                          });

    
    computer.setCalculationFunction(  (rowProxy:anychart.data.TableComputer.RowProxy, context:Object)=>{
        anychart.math.macd.calculationFunction(rowProxy, <anychart.math.macd.Context>context)
    });;


    // computer.addOutputField('macdResult');
    // computer.addOutputField('signalResult');
    // computer.addOutputField('histogramResult');

    var indicatorMapping = data.mapAs(
                                            {
                                              macdResult:  computer.addOutputField('macdResult'),
                                              signalResult:  computer.addOutputField('signalResult'),
                                              histogramResult:  computer.addOutputField('histogramResult'),
                                            }
                                    );



    indicatorMapping.addField("dt", 0);
    indicatorMapping.addField("close", 4);
   //mapping.addField(({value: computer.addOutputField('result')});


    var sel = indicatorMapping.createSelectable().selectAll()
    var iter = sel.getIterator();


    let xN = 0;
    let yN = 0;
    let ySignal = 0;
    let ySignalPrev = 0;
    let nSegmentedline1:Segment[] = [];
    let nSegmentedline2:Segment[] = [];
    let i = 0;

    let testArray = [];
    while (iter.advance()) {



      let macd = iter.get("macdResult");
      let signal = iter.get("signalResult");
      let histogram = iter.get("histogramResult");





     // testArray.push({macdVal:macd, signalVal:signal, histogramVal:histogram, })

      let prevx = i;
      let prevy = yN;
      let ySignalPrev =  ySignal;

      i++; 
      xN = i;//iter.get("dt");

      yN = macd;
      ySignal = signal;

     // console.log([prevx - x]);

      nSegmentedline1.push(
                            {
                              s:{x:prevx, y:prevy},
                              e:{x:xN, y:yN}
                            }
                          )
      
      nSegmentedline2.push(
                              {
                                s:{x:prevx, y:ySignalPrev},
                                e:{x:xN, y:ySignal}
                              }
                          )

                            
    }

   // console.log(testArray);

   // console.log(nSegmentedline1);
   // console.log(nSegmentedline2);


    // let nSegmentedline1:Segment[] = [
    //     {s:{x:1,y:1},e:{x:2,y:2}},
    //     {s:{x:2,y:2},e:{x:3,y:1.5}},
    //     {s:{x:3,y:1.5},e:{x:4,y:1}},
    //     {s:{x:4,y:1},e:{x:5,y:1.5}},
    //     {s:{x:5,y:1.5},e:{x:6,y:0.5}},
    //     {s:{x:6,y:0.5},e:{x:7,y:2.5}},
    //     {s:{x:7,y:2.5},e:{x:8,y:2.5}},
    //     {s:{x:8,y:2.5},e:{x:9,y:2.5}},
    //   ]
    
    // let nSegmentedline2:Segment[] = [
    //     {s:{x:1,y:1.5},e:{x:2,y:1.5}},
    //     {s:{x:2,y:1.5},e:{x:3,y:1.5}},
    //     {s:{x:3,y:1.5},e:{x:4,y:1.5}},
    //     {s:{x:4,y:1.5},e:{x:5,y:1.5}},
    //     {s:{x:5,y:1.5},e:{x:6,y:1.5}},
    //     {s:{x:6,y:1.5},e:{x:7,y:1.5}},
    //     {s:{x:7,y:1.5},e:{x:8,y:1.5}},
    //     {s:{x:8,y:1.5},e:{x:9,y:1.5}},
    //   ]
    
  //  console.log(nSegmentedline1);
 //   console.log(nSegmentedline2);

    let firstSegmentRevIntersectionInformation:PointDirection[] | boolean = [];
    firstSegmentRevIntersectionInformation = findFirstIntersectionsReversedWithCrossDirection(nSegmentedline1, nSegmentedline2)
 //   console.log(firstSegmentRevIntersectionInformation); 

    
     return   firstSegmentRevIntersectionInformation;

}












